export default "__VITE_ASSET__2a027e47__"